import { IconLibrary } from './library.js';
import { systemIconResolver } from './iconset.system.js';
export const fillMutator = (svg) => svg.setAttribute('fill', 'currentColor');
export const addDefaultIconsets = () => {
    const library = IconLibrary.getInstance();
    library.add('system', systemIconResolver, fillMutator);
    library.add('default', (name, setName) => `${library.defaultPath}/${setName}/${name}.svg`, fillMutator);
    library.add('social', (name, setName) => `${library.defaultPath}/${setName}/${name}.svg`, fillMutator);
    library.add('logos', (name, setName) => `${library.defaultPath}/${setName}/${name}.svg`, fillMutator);
};
//# sourceMappingURL=default-sets.js.map